/* Click-to-load video embeds.
 *
 * The markup ships a poster and a link to the video on YouTube. This turns
 * that link into an inline player on the first click, which is the only
 * point at which the visitor has asked for a megabyte of third party
 * JavaScript. With this script absent or broken the link still works, which
 * is why the facade is an anchor and not a button.
 *
 * Focus moves into the iframe after the swap. Without that, activating the
 * control destroys the element that had focus and the browser drops the
 * keyboard user back at the start of the document, which is a worse
 * experience than not embedding at all.
 */
(function () {
  'use strict';

  var facades = document.querySelectorAll('[data-ak-video]');
  if (!facades.length) return;

  var warmed = false;

  /* The handshake with YouTube costs a few hundred milliseconds that can be
     spent while the pointer is still travelling. Done once, on the first
     hint of intent, rather than for every visitor on load. */
  function warm() {
    if (warmed) return;
    warmed = true;
    ['https://www.youtube-nocookie.com', 'https://www.google.com'].forEach(function (host) {
      var l = document.createElement('link');
      l.rel = 'preconnect';
      l.href = host;
      l.crossOrigin = '';
      document.head.appendChild(l);
    });
  }

  function play(a) {
    var id = a.getAttribute('data-ak-video');
    if (!id) return;

    var frame = document.createElement('iframe');
    frame.className = 'ak-vrev__iframe';
    frame.src =
      'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    frame.title = a.getAttribute('data-ak-video-title') || 'Video';
    frame.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    var parent = a.parentNode;
    if (!parent) return;
    parent.replaceChild(frame, a);

    /* Hand the keyboard over to the player rather than to the top of the
       page. tabindex is not needed: an iframe is focusable already. */
    try { frame.focus({ preventScroll: true }); } catch (e) { frame.focus(); }
  }

  Array.prototype.forEach.call(facades, function (a) {
    ['pointerenter', 'focus', 'touchstart'].forEach(function (evt) {
      a.addEventListener(evt, warm, { once: true, passive: true });
    });

    a.addEventListener('click', function (e) {
      /* Leave the modified clicks alone: someone asking for a new tab wants
         the video on YouTube, not an embed they cannot see. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      play(a);
    });
  });
})();
